/**
 * quantityForecasts constants
 */
export const QUANTITY_FORECASTS_LOAD_REQUESTED =
    'QUANTITY_FORECASTS_LOAD_REQUESTED';
export const QUANTITY_FORECASTS_LOAD_SUCCEEDED =
    'QUANTITY_FORECASTS_LOAD_SUCCEEDED';
export const QUANTITY_FORECASTS_LOAD_FAILED = 'QUANTITY_FORECASTS_LOAD_FAILED';

export const QUANTITY_FORECAST_CREATE_REQUESTED =
    'QUANTITY_FORECAST_CREATE_REQUESTED';
export const QUANTITY_FORECAST_CREATE_SUCCEEDED =
    'QUANTITY_FORECAST_CREATE_SUCCEEDED';
export const QUANTITY_FORECAST_CREATE_FAILED =
    'QUANTITY_FORECAST_CREATE_FAILED';

export const QUANTITY_FORECAST_UPDATE_REQUESTED =
    'QUANTITY_FORECAST_UPDATE_REQUESTED';
export const QUANTITY_FORECAST_UPDATE_SUCCEEDED =
    'QUANTITY_FORECAST_UPDATE_SUCCEEDED';
export const QUANTITY_FORECAST_UPDATE_FAILED =
    'QUANTITY_FORECAST_UPDATE_FAILED';

export const QUANTITY_FORECASTS_SET = 'QUANTITY_FORECASTS_SET';
export const QUANTITY_FORECASTS_MERGE = 'QUANTITY_FORECASTS_MERGE';
export const QUANTITY_FORECAST_SET = 'QUANTITY_FORECAST_SET';
